// 导出一个名为getValidValue的函数，该函数用于从参数中获取一个有效的值
export const getValidValue = (params?: {
  value?: string;
  defaultValue?: string;
  allValues?: string[];
}): string => {
  // 解构参数对象，获取value、defaultValue和allValues属性，如果没有提供参数，则默认为空对象
  const { value, defaultValue, allValues } = params || {};

  // 检查allValues是否为一个非空数组，如果不是，则返回空字符串
  if (!Array.isArray(allValues) || !allValues.length) return '';

  // 如果value存在且在allValues数组中，则返回value
  if (!!value && allValues.includes(value)) return value;

  // 如果defaultValue存在且在allValues数组中，则返回defaultValue
  if (!!defaultValue && allValues.includes(defaultValue)) return defaultValue;

  // 如果value和defaultValue都不存在或不在allValues中，则返回allValues数组的第一个元素，如果数组为空，则返回空字符串
  return allValues[0] || '';
};

// 导出一个泛型函数，用于获取有效的值列表
export const getValidListValue = <T extends string | number>(params?: {
  values?: T[]; // 可选的值数组
  defaultValues?: T[]; // 可选的默认值数组
  allValues?: T[]; // 所有可能的值数组
}): T[] => {
  // 解构参数对象，如果没有传入参数，则使用空对象
  const { values, defaultValues, allValues } = params || {};

  // 如果allValues不是数组或者为空数组，则返回空数组
  if (!Array.isArray(allValues) || allValues.length === 0) return [];

  // 初始化一个临时数组用于存放有效的值
  let valuesTmp: T[] = [];

  // 如果values是数组且不为空，则过滤出同时存在于allValues中的值
  if (Array.isArray(values) && values.length > 0) {
    valuesTmp = values.filter((value) => allValues.includes(value));
  }
  // 如果values为空，但defaultValues是数组且不为空，则过滤出同时存在于allValues中的默认值
  else if (Array.isArray(defaultValues) && defaultValues.length > 0) {
    valuesTmp = defaultValues.filter((value) => allValues.includes(value));
  }

  // 如果valuesTmp不为空，则返回valuesTmp，否则返回allValues
  return valuesTmp.length > 0 ? valuesTmp : allValues;
};
